module.exports = __webpack_public_path__ + "static/img/1.d9bf182.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/zh/1.png
// module id = rKhd
// module chunks = 0